export default __webpack_public_path__ + "e602b02ecae6a3dff03478762dd59f93.png";